import { i18n } from '@/locales';
import { convertCase } from '@/utils';
const { t } = i18n;
const lc = 'views.worker.worker_baromoney_history.';
// 주의: 라이더 상태를 의미하는 값은 맞지만 workerDTO의 useYn(OK LEAVE STOP)과는 다름
// https://barogo.slack.com/archives/C04UP4VFCKA/p1712128892011749
export const workerBaromoneyHistoryWorkerStatusType = {
    // 전체
    ALL: 'ALL',
    // 정상
    ACTIVE: 'ACTIVE',
    // 정지
    PAUSE: 'PAUSE',
    // 퇴직
    LEAVE: 'LEAVE',
};
const workerStatusIconMapper = {
    [workerBaromoneyHistoryWorkerStatusType.ACTIVE]: 'ok',
    [workerBaromoneyHistoryWorkerStatusType.PAUSE]: 'stop',
    [workerBaromoneyHistoryWorkerStatusType.LEAVE]: 'leave',
};
const workerBaromoneyHistoryWorkerStatusTypeList = [
    workerBaromoneyHistoryWorkerStatusType.ALL,
    workerBaromoneyHistoryWorkerStatusType.ACTIVE,
    workerBaromoneyHistoryWorkerStatusType.PAUSE,
    workerBaromoneyHistoryWorkerStatusType.LEAVE,
];
const workerBaromoneyHistoryWorkerStatusTypeOptionList = workerBaromoneyHistoryWorkerStatusTypeList
    .map((value) => {
    const text = convertCase(value, 'enum', 'snake');
    let imgIcon = '';
    // "전체" 에 대한 아이콘 무
    if (value !== workerBaromoneyHistoryWorkerStatusType.ALL) {
        imgIcon = workerStatusIconMapper[value];
    }
    return {
        text: t(lc + text),
        value,
        imgIcon,
    };
});
export { workerBaromoneyHistoryWorkerStatusTypeOptionList };
